import React from 'react';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { IconButton } from '@atlaskit/button/new';

const LOOM_BASE_URL = 'https://www.loom.com';

type LoomExternalOpenButtonProps = {
	loomRoute: string;
};

export const LoomExternalOpenButton: React.FC<LoomExternalOpenButtonProps> = ({ loomRoute }) => {
	const loomUrl = new URL(loomRoute, LOOM_BASE_URL);

	const handleClick = () => {
		window.open(loomUrl.toString(), '_blank');
	};

	return (
		<IconButton
			icon={LinkExternalIcon}
			label="Loom External Open"
			onClick={handleClick}
			testId="loom-external-open-button"
		/>
	);
};
